'use strict';

export function init() {
    const scrollTopButton = document.querySelector('.global-header__scroll-top');
    if (!scrollTopButton) return;

    function handleScroll() {
        const scrollPosition = window.scrollY;
        const viewportHeight = window.innerHeight;

        if (scrollPosition > viewportHeight * 0.5) {
            scrollTopButton.classList.add('is-toggled');
        } else {
            scrollTopButton.classList.remove('is-toggled');
        }
    }

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    window.addEventListener('scroll', handleScroll);
    scrollTopButton.addEventListener('click', scrollToTop);
}
